import {DEFAULT_VERTICAL_WIDTH, LAYOUTS_HORIZONTAL, LAYOUTS_LIST, LAYOUTS_VERTICAL} from './constants';

export const layoutValues = {
  [LAYOUTS_VERTICAL]: {
    width: DEFAULT_VERTICAL_WIDTH
  },
  [LAYOUTS_HORIZONTAL]: {
    width: 680
  },
  [LAYOUTS_LIST]: {
    width: 680
  }
};



// WEBPACK FOOTER //
// ./widget-player/layout-values.ts